<template>
  <section class="events">
    <vue-event-calendar :events="events"></vue-event-calendar>
  </section>
</template>

<script>
  import {api} from '@/main.js'
  import Container from "@/components/container/index";
  export default {
    name: 'OnepageEvents',
    components: {Container},
    data () {
      return {
        events: []
      }
    },
    mounted () {
      api.collection.get('events').then(response => {
        this.events = JSON.parse(response.data).entries
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/onepage/events.vue